const ACTIONS = {
	error: 'ERROR',
	abort: 'ABORT',
	ready: 'READY',
	request: 'REQUEST',
	postRequest: 'POST_REQUEST',
	jsonRequest: 'JSON_REQUEST',
	clientUpdate: 'CLIENT_UPDATE',
	clientJsonUpdate: 'CLIENT_JSON_UPDATE',
	updatePath: 'UPDATE_PATH',
	updateLoadingSpinner: 'UPDATE_LOADING_SPINNER',
	updateIframeContainerHeight: 'UPDATE_IFRAME_CONTAINER_HEIGHT',
	registerAccountJwt: 'REGISTER_ACCOUNT_JWT',
	unregisterAccountJwt: 'UNREGISTER_ACCOUNT_JWT',
	unloadAccount: 'UNLOAD_ACCOUNT',
	startRediect: 'START_REDIRECT',
	redirect: 'REDIRECT',
};

ACTIONS.has = (key='') => {
	return !!ACTIONS[key.toLowerCase()];
};

module.exports = ACTIONS;
